import * as React  from 'react';

const CancelComplete = (props) => {
  return(
    <>
      <div className="mx-auto checkout-complete">
        <span id="ticket-purchase-message">チケットをキャンセルしました。</span>
        <br/>
        <span id="total-fee-message">{Number(props.total_fee).toLocaleString()}円</span>
        <br/>
        <a className="btn btn-primary ml5 form-btn"
              href={`/tickets/data/purchase${props.company_id ? '?company_id=' + props.company_id : ''}`}>チケット購入画面に戻る</a>
      </div>
     </>
  )
}

export default CancelComplete
